import { StaffRole } from '../../types';

// Mock data for Staff Roles page
// HoD, HoY, SLT assignments

export const mockStaffRoles: StaffRole[] = [
  // Senior Leadership Team (SLT)
  {
    id: 'role-slt-head',
    title: 'Head Teacher',
    description: 'Overall responsibility for the school',
    level: 'SLT',
    responsibilities: [
      'Strategic leadership and vision',
      'Overall school performance',
      'Budget management',
      'Staff recruitment and development',
      'Stakeholder engagement',
    ],
    assignedTeacherId: 'teacher-1',
  },
  {
    id: 'role-slt-deputy',
    title: 'Deputy Head Teacher',
    description: 'Deputy to the Head Teacher with focus on curriculum',
    level: 'SLT',
    responsibilities: [
      'Curriculum oversight',
      'Teaching and learning standards',
      'Staff professional development',
      'Parent liaison',
    ],
    assignedTeacherId: 'teacher-2',
  },
  {
    id: 'role-slt-assistant',
    title: 'Assistant Head Teacher - Pastoral',
    description: 'Pastoral care and student welfare',
    level: 'SLT',
    responsibilities: [
      'Student welfare and safeguarding',
      'Behaviour management',
      'Attendance monitoring',
      'PSHE coordination',
    ],
    assignedTeacherId: 'teacher-3',
  },
  {
    id: 'role-slt-operations',
    title: 'Assistant Head Teacher - Operations',
    description: 'Operational management including timetabling',
    level: 'SLT',
    responsibilities: ['Timetabling and scheduling', 'Cover management', 'Resource allocation', 'Data management'],
    assignedTeacherId: 'teacher-4',
  },

  // Heads of Department (HoD)
  {
    id: 'role-hod-maths',
    title: 'Head of Mathematics',
    description: 'Leadership of the Mathematics department',
    level: 'HoD',
    responsibilities: [
      'Department curriculum planning',
      'Staff mentoring and development',
      'Budget management for department',
      'Exam results analysis',
      'Resource procurement',
    ],
    assignedTeacherId: 'teacher-5',
  },
  {
    id: 'role-hod-english',
    title: 'Head of English',
    description: 'Leadership of the English department',
    level: 'HoD',
    responsibilities: [
      'Department curriculum planning',
      'Literacy across the curriculum',
      'Staff mentoring',
      'Exam preparation and analysis',
    ],
    assignedTeacherId: 'teacher-6',
  },
  {
    id: 'role-hod-science',
    title: 'Head of Science',
    description: 'Leadership of the Science department',
    level: 'HoD',
    responsibilities: [
      'Science curriculum coordination',
      'Laboratory safety and management',
      'Staff development',
      'Science enrichment activities',
    ],
    assignedTeacherId: 'teacher-7',
  },
  {
    id: 'role-hod-humanities',
    title: 'Head of Humanities',
    description: 'Leadership of History, Geography, and RE',
    level: 'HoD',
    responsibilities: [
      'Humanities curriculum integration',
      'Cross-curricular projects',
      'Department coordination',
      'Educational visits',
    ],
    assignedTeacherId: 'teacher-8',
  },
  {
    id: 'role-hod-languages',
    title: 'Head of Modern Foreign Languages',
    description: 'Leadership of MFL department',
    level: 'HoD',
    responsibilities: [
      'Language curriculum planning',
      'International exchanges',
      'Staff development',
      'Foreign language promotion',
    ],
    assignedTeacherId: 'teacher-9',
  },
  {
    id: 'role-hod-arts',
    title: 'Head of Creative Arts',
    description: 'Leadership of Art, Music, and Drama',
    level: 'HoD',
    responsibilities: [
      'Arts curriculum coordination',
      'Performance and exhibition planning',
      'Department budget',
      'Creative enrichment',
    ],
    assignedTeacherId: 'teacher-10',
  },
  {
    id: 'role-hod-pe',
    title: 'Head of Physical Education',
    description: 'Leadership of PE and Sports',
    level: 'HoD',
    responsibilities: [
      'PE curriculum delivery',
      'Sports fixtures and competitions',
      'Health and fitness promotion',
      'Sports equipment management',
    ],
    assignedTeacherId: 'teacher-11',
  },
  {
    id: 'role-hod-ict',
    title: 'Head of ICT and Computing',
    description: 'Leadership of ICT department',
    level: 'HoD',
    responsibilities: [
      'ICT curriculum planning',
      'Digital literacy across school',
      'IT infrastructure liaison',
      'E-safety coordination',
    ],
    assignedTeacherId: 'teacher-12',
  },

  // Heads of Year (HoY)
  {
    id: 'role-hoy-7',
    title: 'Head of Year 7',
    description: 'Pastoral care for Year 7 students',
    level: 'HoY',
    responsibilities: [
      'Year 7 transition support',
      'Student welfare and discipline',
      'Parent communication',
      'Form tutor coordination',
      'Attendance monitoring',
    ],
    assignedTeacherId: 'teacher-13',
  },
  {
    id: 'role-hoy-8',
    title: 'Head of Year 8',
    description: 'Pastoral care for Year 8 students',
    level: 'HoY',
    responsibilities: [
      'Year 8 student support',
      'Behaviour management',
      'Academic progress monitoring',
      'Parent liaison',
    ],
    assignedTeacherId: 'teacher-14',
  },
  {
    id: 'role-hoy-9',
    title: 'Head of Year 9',
    description: 'Pastoral care for Year 9 students',
    level: 'HoY',
    responsibilities: [
      'Year 9 options guidance',
      'Student welfare',
      'Intervention coordination',
      'Careers advice support',
    ],
    assignedTeacherId: 'teacher-15',
  },
  {
    id: 'role-hoy-10',
    title: 'Head of Year 10',
    description: 'Pastoral care for Year 10 students',
    level: 'HoY',
    responsibilities: [
      'GCSE transition support',
      'Student mentoring',
      'Work experience coordination',
      'Exam preparation monitoring',
    ],
    assignedTeacherId: 'teacher-16',
  },
  {
    id: 'role-hoy-11',
    title: 'Head of Year 11',
    description: 'Pastoral care for Year 11 students',
    level: 'HoY',
    responsibilities: [
      'GCSE exam support',
      'Post-16 transition planning',
      'Student intervention',
      'Revision programmes',
    ],
    assignedTeacherId: 'teacher-17',
  },
  {
    id: 'role-hoy-12',
    title: 'Head of Year 12',
    description: 'Pastoral care for Year 12 students',
    level: 'HoY',
    responsibilities: ['Sixth form transition', 'A-Level guidance', 'UCAS support', 'Study skills development'],
    assignedTeacherId: 'teacher-18',
  },
  {
    id: 'role-hoy-13',
    title: 'Head of Year 13',
    description: 'Pastoral care for Year 13 students',
    level: 'HoY',
    responsibilities: [
      'University application support',
      'A-Level exam preparation',
      'Careers guidance',
      'Apprenticeship liaison',
    ],
    assignedTeacherId: 'teacher-19',
  },
];

export const getRolesByLevel = (level: StaffRole['level']): StaffRole[] => {
  return mockStaffRoles.filter((role) => role.level === level);
};

export const getRoleByTeacher = (teacherId: string): StaffRole[] => {
  return mockStaffRoles.filter((role) => role.assignedTeacherId === teacherId);
};

export const getUnassignedRoles = (): StaffRole[] => {
  return mockStaffRoles.filter((role) => !role.assignedTeacherId);
};

export const roleLevelHierarchy: Record<StaffRole['level'], number> = {
  'Head Teacher': 5,
  SLT: 4,
  HoD: 3,
  HoY: 2,
  Teacher: 1,
};

export default mockStaffRoles;
